import queryString from 'query-string';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { useService } from '@atlassian/jira-common-services/src/use-service/index.tsx';
import { fireCmdbErrorAnalytics } from '@atlassian/jira-servicedesk-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge/src/utils/fire-analytics';
import { performCmdbGetRequest } from '@atlassian/jira-servicedesk-cmdb-client/src/fetch.tsx';
import { useCmdbRestBaseUrl } from '@atlassian/jira-servicedesk-insight-shared-utils/src/common/utils/use-cmdb-rest-base-url/index.tsx';
import type { BitbucketRepoResultSetResponse } from '../common/types.tsx';

export const useBitbucketReposSearch = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const restBaseUrl = useCmdbRestBaseUrl();

	const searchBitbucketRepos = async (query: string): Promise<BitbucketRepoResultSetResponse> => {
		try {
			const url = `${restBaseUrl}/bitbucket/repositories?${queryString.stringify({
				query,
			})}`;
			const projects: BitbucketRepoResultSetResponse = await performCmdbGetRequest(url);
			fireTrackAnalytics(createAnalyticsEvent({}), 'insightSearchBitbucketRepos succeeded');
			return projects;
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			fireCmdbErrorAnalytics({
				error,
				meta: {
					id: 'insightSearchBitbucketRepos',
					teamName: 'falcons',
					packageName: 'jiraServicedeskInsightBitbucketRepoPicker',
				},
			});
			throw error;
		}
	};

	const { data, loading, error, fetch } = useService<BitbucketRepoResultSetResponse, string>(
		searchBitbucketRepos,
	);

	return [{ data, loading, error }, { searchBitbucketRepos: fetch }] as const;
};
